import { Link } from 'react-router-dom'
import Icon from '../../general/Icon'
import { Heading } from '../../general'
import styled from 'styled-components'

export type ComingSoonCardProps = {
  backgroundColor?: string
  backgroundImage?: string
  title: string
  subtitle: string
  description: string
  listItems: string[]
  footerText: string
  findOutMoreURL?: string | undefined
}

interface ContainerProps {
  backgroundImage?: string
  backgroundColor?: string
}

export default function ComingSoonCard({
  backgroundColor,
  backgroundImage,
  title,
  subtitle,
  description,
  listItems,
  footerText,
  findOutMoreURL,
}: ComingSoonCardProps) {
  return (
    <Container
      backgroundColor={backgroundColor}
      backgroundImage={backgroundImage}
    >
      <Wrapper>
        <TitleContainer>
          <Title level={1}>{title}</Title>
        </TitleContainer>
        <div>
          <SubitleContainer>
            <Subtitle level={2}>{subtitle}</Subtitle>
          </SubitleContainer>
          <Description>{description}</Description>
          <List>
            {listItems?.map((item) => (
              <ListItem key={item}>{item}</ListItem>
            ))}
          </List>
          <Footer>
            {footerText}
            {findOutMoreURL && (
              <FindOutMoreLink
                to={findOutMoreURL}
                target="_blank"
                rel="noreferrer"
              >
                Find out more
                <RightArrow name="RightOutlined" />
              </FindOutMoreLink>
            )}
          </Footer>
        </div>
      </Wrapper>
    </Container>
  )
}

const Container = styled.div<ContainerProps>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 25px;
  background-size: 90%;
  background-position-x: 35%;
  background-position-y: center;
  background-repeat: no-repeat;
  color: ${({ theme }) => theme.color.neutral.color11};
  margin-bottom: 24px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    background-size: 250%;
    background-position-x: 5%;
    background-position-y: bottom;
  }
`

const Wrapper = styled.div`
  padding: 40px 64px;

  ${({ theme }) => theme.mediaQueries.mobileDown} {
    padding: 16px;
  }
`
const Title = styled(Heading)`
  font-size: 32px;
`
const TitleContainer = styled.div`
  padding-bottom: 10px;
`
const Subtitle = styled(Heading)`
  font-size: 24px;
`
const SubitleContainer = styled.div`
  padding-bottom: 16px;
`
const Description = styled.p`
  font-size: 18px;
  margin-bottom: 0;
`
const List = styled.ul`
  margin: 0 0 24px;
`
const ListItem = styled.li`
  font-size: 16px;
  font-weight: 500;
`
const Footer = styled.div`
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
`
const FindOutMoreLink = styled(Link)`
  color: ${({ theme }) => theme.color.neutral.color11};
  text-decoration: 'underline';
`
const RightArrow = styled(Icon)`
  font-size: 14px;
  margin-left: 2px;
`
